// removed by extract-text-webpack-plugin
module.exports = {"title":"src-templates----page-module---title---2dbCf"};


//////////////////
// WEBPACK FOOTER
// ./src/templates/page.module.css
// module id = 299
// module chunks = 96961042003272